// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"834":"5186785e","959":"f12590a3"}[chunkId] + ".chunk.js";
};